module.exports = __webpack_public_path__ + "static/media/pic5.270d02a1.jpg";